import React from 'react';
import { connect } from 'react-redux';

import ConnectListingOverlayCard from './connect_listing_overlay_card';
import OffMarketOverlayCard from './off_market_overlay_card';

type Props = {
  offMarketSearch: boolean;
}

function InfoWindow({ offMarketSearch }: Props) {
  if (offMarketSearch) {
    return <OffMarketOverlayCard />;
  } else {
    return <ConnectListingOverlayCard />;
  }
}

const mapStateToProps = ({ ui: { offMarketSearch } }) => ({ offMarketSearch });

export default connect(mapStateToProps)(InfoWindow);
